import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const AdditionalCostsActions = createActionGroup({
    source: 'Margin Calculator - Additional Costs',
    events: {
        revealAdditionalCostsDetailsClicked: emptyProps(),
        setInternalCosts: props<{ internalCosts: number }>(),
        setAYABooster: props<{ ayaBooster: number }>()
    }
});
